import { Image, Layout } from 'antd';
import getConfig from 'next/config';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { ReactNode } from 'react';

export interface OnboardingSiderProps {
  children: ReactNode;
  onCollapse: (value: boolean) => void;
}

export function OnboardingSider({
  children,
  onCollapse,
}: OnboardingSiderProps) {
  const { publicRuntimeConfig } = getConfig();
  const { t } = useTranslation('common');

  return (
    <Layout.Sider
      className="min-h-screen"
      breakpoint="md"
      collapsedWidth={0}
      trigger={null}
      width={256}
      onCollapse={onCollapse}
    >
      <Link href="/" passHref>
        <div className="px-6 py-3 h-[64px]">
          <Image
            src={`${publicRuntimeConfig.staticFolder}/logo-full.svg`}
            preview={false}
            height="40"
            alt={t('scv_logo')}
          />
        </div>
      </Link>
      {children}
    </Layout.Sider>
  );
}

export default OnboardingSider;
